// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3fFyq","visuallyhidden":"_3u0Kk","hide-text":"_2QjPz","center":"_3bnTH","noprint":"_2mQzm","map":"_33wbj"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-map/styles/feature.scss
 ** module id = 136
 ** module chunks = 2
 **/